import React from 'react';
import { IconType } from 'react-icons';

interface StatusBadgeProps {
  label: string;
  color?: string;
  icon?: IconType;
  textColor?: string;
  minWidth?: string;
  padding?: string;
  borderRadius?: string;
}

const Status: React.FC<StatusBadgeProps> = ({
  label,
  color = 'rgba(9, 175, 9, 0.655)',
  icon: Icon,
  textColor = '#fff',
  minWidth = '60px',
  padding = '8px 12px',
  borderRadius = '10px',
}) => {
  return (
    <div
      style={{
        textAlign: 'left',
        justifySelf: 'flex-start',
        marginLeft: '-10px',
      }}
    >
      <span
        style={{
          backgroundColor: color,
          borderRadius,
          padding,
          color: textColor,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          minWidth,
        }}
      >
        {Icon && <Icon size={16} />}
        {label}
      </span>
    </div>
  );
};

export default Status;
